import { FC, useEffect, useState } from "react";
import styles from './GoodsGroupAllGrid.module.scss';
import { LoadingStatus } from "../../../@types/enumsGlobal";
import { DefaultGrid } from "../../../components/grids/default/defaultGrid";
import { PluginWrapper, ToolbarWrapper } from "../../../components/plugins";
import useGridFilter, { CreateSelectorGridFilter } from "../../../system/hooks/useGridFilter";
import { useAppContext } from "../../../system/providers/appContextProvider";
import { GoodsGroupDataProvider } from "../../../Services/DataProviders/GoodsGroupDataProvider";
import { IGoodsGroupAllViewDTO } from "../../../libs/coreapi-dto/dirs/goodsGroup";
import DefaultDictionaryCommandsPanel from "../../../components/commandsPanels/DefaultDictionaryCommandsPanel";
import GoodsGroupCreatorModal from "./GoodsGroupCreatorModal";
import { sortBySelectedIdGlobal } from "../../../system/hooks/useCombinedData";


export const GoodsGroupAllGrid: FC<IGridProps> = (props) => {
    const appCtx = useAppContext();
    const goodsGroupADP = new GoodsGroupDataProvider(appCtx.coreApiService);

    const [loadingStatus, setLoadingStatus] = useState<LoadingStatus>(LoadingStatus.InProcess);
    const [data, setData] = useState<IGoodsGroupAllViewDTO[]>([]);
    const [totalCount, setTotalCount] = useState(0);
    const [viewState, setViewState] = useState<GridStateType>("view");
    const [gridFilter, dispatchGridFilter] = useGridFilter(CreateSelectorGridFilter);
    const [selectedItem, setSelectedItem] = useState<IGridRow>();
    const [selectedItems, setSelectedItems] = useState<IGridRow[]>(props.data ?? []);

    const handleItemsChange = (newItems: IGridRow[]) => {
        setSelectedItems(newItems);
        props?.onMultipleSelect?.(newItems);
    };

    useEffect(() => {
        if(props.multipleSelect && props.isSearchForMultyselect) {
            goodsGroupADP.getViewAll(gridFilter, (data, totalCount) => {
                if (totalCount > gridFilter.numberPerPage) {
                    const allDataFilter = { ...gridFilter, numberPerPage: totalCount, pageNumber: 1 };
                    goodsGroupADP.getViewAll(allDataFilter, (data, totalCount) => {

                        if (props.isProAptekaEnabled && props.dataFromPluginGridSelectorInput && props.dataFromPluginGridSelectorInput?.length > 0) {
                            const selectedIdSet = new Set(
                                props.dataFromPluginGridSelectorInput
                                    .map(item => item.idGlobal)
                                    .filter(Boolean) as (string | number)[]
                            );

                            const selectedItems: typeof data = [];
                            const restItems: typeof data = [];

                            for (const item of data) {
                                if (item.idGlobal && selectedIdSet.has(item.idGlobal)) {
                                    selectedItems.push(item);
                                } else {
                                    restItems.push(item);
                                }
                            }

                            const restItemsMarketingTrue = restItems.filter(item => item.isMarketing);
                            const restItemsMarketingFalse = restItems.filter(item => !item.isMarketing);

                            restItemsMarketingTrue.sort((a, b) => {
                                if (a.name && b.name) {
                                    return a.name.localeCompare(b.name);
                                }
                                return 0;
                            });

                            restItemsMarketingFalse.sort((a, b) => {
                                if (a.name && b.name) {
                                    return a.name.localeCompare(b.name);
                                }
                                return 0;
                            });

                            data = [...selectedItems, ...restItemsMarketingTrue, ...restItemsMarketingFalse];
                        } else if (props.isProAptekaEnabled) {
                            const itemsMarketingTrue = data.filter(item => item.isMarketing);
                            const itemsMarketingFalse = data.filter(item => !item.isMarketing);

                            itemsMarketingTrue.sort((a, b) => {
                                if (a.name && b.name) {
                                    return a.name.localeCompare(b.name);
                                }
                                return 0;
                            });

                            itemsMarketingFalse.sort((a, b) => {
                                if (a.name && b.name) {
                                    return a.name.localeCompare(b.name);
                                }
                                return 0;
                            });

                            data = [...itemsMarketingTrue, ...itemsMarketingFalse];
                        }

                        const sortedData = sortBySelectedIdGlobal(
                            data,
                            props.dataFromPluginGridSelectorInput
                        );
                        setData(sortedData)
                        setTotalCount(totalCount)
                        data.length > 0 ? setLoadingStatus(LoadingStatus.Completed) : setLoadingStatus(LoadingStatus.NoData)
                    })
                } else {
                    goodsGroupADP.getViewAll(gridFilter, (data, totalCount) => {
                        if (props.isProAptekaEnabled) {
                            const itemsMarketingTrue = data.filter(item => item.isMarketing);
                            const itemsMarketingFalse = data.filter(item => !item.isMarketing);

                            itemsMarketingTrue.sort((a, b) => {
                                if (a.name && b.name) {
                                    return a.name.localeCompare(b.name);
                                }
                                return 0;
                            });

                            itemsMarketingFalse.sort((a, b) => {
                                if (a.name && b.name) {
                                    return a.name.localeCompare(b.name);
                                }
                                return 0;
                            });

                            data = [...itemsMarketingTrue, ...itemsMarketingFalse];
                        }
                        setData(data)
                        setTotalCount(totalCount)
                        data.length > 0 ? setLoadingStatus(LoadingStatus.Completed) : setLoadingStatus(LoadingStatus.NoData)
                    })
                }
            })
        } else {
            goodsGroupADP.getViewAll(gridFilter, (data, totalCount) => {
                setData(data)
                setTotalCount(totalCount)
                data.length > 0 ? setLoadingStatus(LoadingStatus.Completed) : setLoadingStatus(LoadingStatus.NoData)
            })
        }
    }, [viewState, gridFilter])

    return (
        <PluginWrapper>
            <ToolbarWrapper className={styles.toolBarWrapper}>
                <DefaultDictionaryCommandsPanel
                    selectedItem={[selectedItem, setSelectedItem]}
                    selectedItems={[selectedItems,setSelectedItems]}
                    gridFilter={[gridFilter, dispatchGridFilter]}
                    dataProvider={goodsGroupADP}
                    creatorModalJsx={GoodsGroupCreatorModal}
                    pluginSettings={props.plugin}
                    setViewState={(vs) => setViewState(vs)}
                    showGroupProcessing={props.showGroupProcessing}
                    popOverReport={{
                        items: props.dataFromPluginGridSelectorInput ? selectedItems : [],
                        onItemsChange: handleItemsChange
                    }}
                />
            </ToolbarWrapper>
            {
                <DefaultGrid
                    gridId={props.gridId}
                    separator
                    singleDirectory
                    data={data}
                    loadingStatus={loadingStatus}
                    setLoadingStatus={setLoadingStatus}
                    filter={gridFilter}
                    getView={(gridFilter,callback) => {
                        goodsGroupADP.getViewAll(gridFilter, (entities) => {
                            callback(entities)
                            setSelectedItem(undefined);
                        })
                    }}
                    totalCount={totalCount}
                    dataProvider={goodsGroupADP}
                    selectedItem={selectedItem}
                    selectedItems={selectedItems}
                    onSelect={(row) => {
                        setSelectedItem(row)
                        props.onSelect?.(row)
                    }}
                    onMultipleSelect={(rows) => {
                        setSelectedItems(rows)
                        props?.onMultipleSelect?.(rows)
                    }}
                    multipleSelect={props.multipleSelect}
                    plugin={props.plugin}
                    onSort={(i) => dispatchGridFilter({ type: "sort", payload: i.propertyName })}
                    onFilterDelete={(i) => dispatchGridFilter({ type: "deleteColumnFilter", payload: i.propertyName })}
                    onPageNumberChange={(n) => dispatchGridFilter({ type: "changePageNumber", payload: { pageNumber: n } })}
                    onNumberPerPageChange={(n) => dispatchGridFilter({ type: "changeNumberPerPage", payload: { numberPerPage: n } })}
                    onEnter={() => setViewState("edit")}
                    isSearchForMultyselect={props.isSearchForMultyselect}
                />
            }
        </PluginWrapper>
    )
}